module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAM1BMVEUAAAB/f/9Jbf9Sbf9Pav9Mbf9Na/9Na/9Oav9Nav9Na/9Oa/9Nav9Oav9Oa/9Nav9Nav/YM31+AAAAEHRSTlMAAhUcHTZPvb7U1dna29z48snVpgAAAH9JREFUSMftlNEKgDAIRZtbbra23f//2jCoXkYg9FCx86TCAQW50zT4EY5LZWcQKAKJDIIXQLxBCCqEIXxCcOTDwZyBPJ+tp95fcRJlUdYGtFWrfSaRO0LFDaUjlDuh9laKcpJ1pXz1iZ84evzSDwRzkFECoiUqHddiCuPB69kAGz8MbGSFjMIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bluePlus.png
// module id = stGg
// module chunks = 1